var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95671 27.2344C3.87331 27.2121 0.495605 19.2994 0.495605 15.2697C0.495605 8.68714 5.69758 7.24604 7.70238 7.24604C8.60586 7.24604 9.57059 7.58284 10.4215 7.88087C11.0165 8.08877 11.6319 8.30339 11.9742 8.30339C12.1791 8.30339 12.6618 8.12082 13.0881 7.96064C13.9971 7.61712 15.1282 7.19019 16.4453 7.19019C16.4477 7.19019 16.4509 7.19019 16.4532 7.19019C17.4367 7.19019 20.4188 7.39508 22.2117 9.95091L22.6317 10.55L22.0273 10.9829C21.1638 11.6014 19.5883 12.7295 19.5883 14.9642C19.5883 17.611 21.3726 18.6288 22.2298 19.1184C22.6081 19.3345 22.9998 19.5573 22.9998 20.0446C22.9998 20.3628 20.3246 27.1949 16.4398 27.1949C15.4892 27.1949 14.8173 26.9237 14.2246 26.6845C13.6249 26.4423 13.1076 26.2337 12.2528 26.2337C11.8195 26.2337 11.2716 26.4282 10.6915 26.6346C9.89876 26.9155 9.0015 27.2344 7.9834 27.2344H7.95671Z",
    fill: "#008258"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6732 0.508789C16.769 3.8284 14.2999 6.13139 11.8337 5.98696C11.4273 3.33779 14.2996 0.508789 16.6732 0.508789Z",
    fill: "#008258"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/appleIcon.881237450e2ac5d3c74d07df103058f5.svg";
export { ForwardRef as ReactComponent };